/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class SelectDealRoomDialog extends NoboxEntityDialog<LeadRow, any> {
        protected getFormKey() { return Chat.SelectDealRoomForm.formKey; }
        protected getIdProperty() { return CRM.DealsRow.idProperty; }
        protected getLocalTextPrefix() { return CRM.DealsRow.localTextPrefix; }
        protected getNameProperty() { return CRM.DealsRow.nameProperty; }
        protected getService() { return CRM.DealsService.baseUrl; }
        protected getDeletePermission() { return CRM.DealsRow.deletePermission; }
        protected getInsertPermission() { return CRM.DealsRow.insertPermission; }
        protected getUpdatePermission() { return CRM.DealsRow.updatePermission; }

        protected form = new Chat.SelectDealRoomForm(this.idPrefix);
        public IdRoom: number;
        public callback = (response) => {

        }
        protected updateLink() {
            var $form = this.form;
            var $this = this;
            //Q.serviceCall({
            //    blockUI: false,
            //    request: {
            //        EntityId: this.IdRoom,
            //        Entity: {
            //            DealId: $form.DealId.value
            //        }
            //    },
            //    url: `/Services/${ChatroomsService.baseUrl}/Update`,
            //    onSuccess: function (response) {
            //        $this.callback($form.DealId.value)
            //        $this.dialogClose();
            //    }
            //})
            $this.callback($form.DealId.value)
            $this.dialogClose();
        }
        protected getToolbarButtons() {
            var buttons = [] as Serenity.ToolButton[];
            buttons.push({
                title: "Apply",
                icon: "fa-check text-blue",
                onClick: () => {
                    if (this.validateForm()) {
                        this.updateLink();
                    }
                }
            });
            return buttons;
        }
        protected getEntityTitle(): string {
            var entityType = super.getEntitySingular();

            // get name field value of record this dialog edits
            let name = this.getEntityNameFieldValue() || "";

            // you could use format with a local text, but again demo...
            return 'Select ' + entityType;
        }
        constructor(container?: JQuery) {
            super(container);
            var $form = this.form;
        }

        protected updateInterface() {
            super.updateInterface();
            var $form = this.form;
        }

        protected onSaveSuccess(response) {
            super.onSaveSuccess(response);
            this.dialogClose();
        }
    }
}